<template>
  <div>
	<!--版权说明-->
	<div class="link">
		<div class="container" style="text-align: center;">
			<div class="footer-state">
				<!-- 版权声明：未经食安通书面许可，任何人不得盗链、抄袭本网站功能及资源，更不得用于商业目的。否则，食安通将依法追究其法律责任。 -->
				版权声明：未经我单位书面授权，任何单位及个人不得使用本网站功能及资源用于从事商业活动，否则，我单位将追究其法律责任。
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
	<!-- FOOTER -->
	<div class="footer">
		<div class="container">
			<div class="foot-logo pull-left hidden-xs">
				<!-- <img style="width:150px;border-radius: 8px;" src="../assets/img/database-logo.png" alt="热带水果品质与营养基础数据库系统"> -->
			</div>
      <div class="foot-info hidden-xs">

          <span>单位名称：<i>中国热带农业科学院农产品加工研究所</i></span>

          <span>电话 : 0758-2224909</span> <span>邮箱：rdsgpzyy@163.com</span>

          <span>单位地址：<i>广东湛江市霞山区人民大道南48号</i></span>

      </div>
			<!-- <div class="foot-info pull-left hidden-xs">
				<div>
					<span>公司名称：<i>中国热带农业科学院农产品加工研究所</i></span>
				</div>
				<div>
					<span>电话 : 0758-2224909</span> <span>邮箱：rdsgpzyy@163.com</span>
				</div>
				<div>
					<span>公司地址：<i>广东湛江市霞山区人民大道南48号</i></span>
				</div>
				<div>
				</div>
			</div> -->
			<div class="pull-right foot-img-box">
				<!-- <div class="foot-img">
					<img src="../assets/img/erweima1.png" alt="扫码关注食安通官微公众号">
				</div>

				<div class="foot-img">
					<img src="../assets/img/zs-wps.png" alt="给食安通赞赏">
				</div> -->
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  data() {
    return {
      count: 0
    }
  }
}
</script>
<style>
  .footer .container {
    text-align: center;
    width:1200px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue